import React from "react";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { useLang } from "@/i18n";
import { useSettings } from "@/context/SettingsContext";
import { Card } from "@/components/ui/card";

export const ContactCard = () => {
  const { t } = useLang();
  const { settings } = useSettings();
  const c = settings.contacts;
  return (
    <Card data-testid="contact-card" className="p-5 space-y-3">
      <h3 className="font-display font-semibold text-lg flex items-center gap-2">
        <MapPin className="h-4 w-4 text-primary" /> {t("contact_title")}
      </h3>
      <div className="text-sm text-muted-foreground">{t("contact_managers")}: <span className="font-semibold text-foreground">{c.managers}</span></div>
      <a href={`https://wa.me/${c.whatsapp_intl}`} target="_blank" rel="noreferrer"
         data-testid="contact-whatsapp"
         className="flex items-center justify-between gap-2 rounded-lg border border-border px-3 py-2.5 hover:border-primary transition-colors">
        <span className="flex items-center gap-2 text-sm font-medium"><MessageCircle className="h-4 w-4 text-emerald-500" /> {c.whatsapp}</span>
        <span className="text-xs font-mono px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400">{t("wa_available")}</span>
      </a>
      <a href={`tel:${(c.uk_phone || "").replace(/\s/g, "")}`}
         data-testid="contact-ukphone"
         className="flex items-center justify-between gap-2 rounded-lg border border-border px-3 py-2.5 hover:border-primary transition-colors">
        <span className="flex items-center gap-2 text-sm font-medium"><Phone className="h-4 w-4 text-blue-500" /> {c.uk_phone}</span>
        <span className="text-xs font-mono px-2 py-0.5 rounded-full bg-muted text-muted-foreground">{t("wa_not")}</span>
      </a>
    </Card>
  );
};

export const Footer = () => {
  const { t } = useLang();
  const { settings } = useSettings();
  const c = settings.contacts;
  return (
    <footer className="border-t border-border mt-16 py-8 text-center text-sm text-muted-foreground">
      <div className="max-w-7xl mx-auto px-4 space-y-1">
        <p className="font-display font-semibold text-foreground">{t("brand")}</p>
        <p>{c.managers} · WhatsApp {c.whatsapp} · UK {c.uk_phone}</p>
      </div>
    </footer>
  );
};
